import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { Button, Modal } from 'react-bootstrap';
import keymaster from 'keymaster';
import moment from 'moment';
import roles from '../utils/roles';

import CommanderConsoleWidget from './CommanderConsoleWidget';
import LogEntryDayListWidget from './LogEntryDayListWidget';
import LogOverviewHeader from './LogOverviewHeader';
import Spinner from './Spinner';
import SubmitModal from './SubmitModal';

import floatingTaskActions from '../actions/floatingTaskActionCreators';
import * as logEntryActions from '../actions/logEntryActionCreators';
import projectActions from '../actions/projectActionCreators';
import taskActions from '../actions/taskActionCreators';
import timesheetActions from '../actions/timesheetActionCreators';
import userActions from '../actions/userActionCreators';
import Time from "../utils/time";

require.ensure([], () => {
    require('./DatePicker.less');
    require('./LogOverview.less');
    require('./Material-Design-Iconic.less');
});

class LogOverview extends React.Component {

    constructor(props, context) {
        super(props, context);

        let date;
        if(this.props.location.query.week) {
            let yearWeek = this.props.location.query.week;
            let year = yearWeek.substring(0, 4);
            let week = yearWeek.substring(4, 6);
            date = moment().year(year).isoWeek(week).day(1);
        } else {
          date = moment(new Date(), "YYYY-MM-DD").startOf('isoweek');
        }

        this.day = [];
        this.state = {
            date,
            showCommander: false,
            submitModalClosed: false
        };
    }

    // LIFECYCLE METHODS
    componentDidMount = () => {
        moment.updateLocale('en', {
            week: { doy: 4 }
        });

        if(!roles.userHasAnyOfRoles(JSON.parse(localStorage.getItem('user')), ['USER'])) {
            browserHistory.push('/');
        }

        this.props.routeParams.date = this.state.date;

        this.props.dispatch(projectActions.setCurrentView("LOG_OVERVIEW"));
        this.props.dispatch(logEntryActions.loadOnWeek(this.state.date));
        this.props.dispatch(floatingTaskActions.loadAll());
        this.props.dispatch(projectActions.loadProjects());
        this.props.dispatch(taskActions.loadTasks());
        this.props.dispatch(userActions.loadPms());
        this.props.dispatch(userActions.loadCurrentUser());

        let currentUser = JSON.parse(localStorage.getItem('user'));
        this.loadTimesheetUser(currentUser);

        keymaster('ctrl+k', () => {this.openCommander(); return false;});
        keymaster('left', this.decrementWeek);
        keymaster('right', this.incrementWeek);

        window.addEventListener("resize", this.updateDimensions);
    }

    componentWillUnmount = () => {
        keymaster.unbind('left');
        keymaster.unbind('right');
        keymaster.unbind('ctrl+k');

        window.removeEventListener("resize", this.updateDimensions);
    }

    updateDimensions = () => {
        this.setState({width: window.innerWidth});
    }

    // EVENT HANDLERS

    handleCloseCommander = () => {
        this.setState({
            showCommander: false
        });
    }

    handleCloseSubmitModal = () => {
        this.setState({
            submitModalClosed: true
        });
    }

    handleDateSelect = (date) => {
        moment.updateLocale('en', {
            week: {
                doy: 4
            }
        });

        let newDate = moment(date, "YYYY-MM-DD").startOf('isoweek');
        this.props.routeParams.date = newDate;

        this.setState({
            date: newDate
        }, () => {
            this.props.dispatch(logEntryActions.loadOnWeek(this.state.date));
            this.loadTimesheet();
            this.handleResetSubmitModal();
        });
    }

    handleResetSubmitModal = () => {
        if (this.state.submitModalClosed)
            this.setState({
                submitModalClosed: false
            });
    }

    handleSubmitTimesheet = () => {
        this.props.dispatch(timesheetActions.submit(this.props.currentTimesheet));
    }

    // OTHER METHODS

    closeAllPopovers = () => {
        for (let i = 1; i < 8; ++i) {
            this.day[i].closePopovers();
        }
    }

    decrementWeek = () => {
        if (this.props.loading) {
            return;
        }

        this.setState({
            selectDate: false
        });

        let date = this.state.date.subtract(7, 'days');
        this.props.routeParams.date = date;

        this.setState({
            date: date,
            showCommander: false
        }, () => {
            this.props.dispatch(logEntryActions.loadOnWeek(this.state.date));
            this.loadTimesheet();
            this.handleResetSubmitModal();
        });
    }

    //TODO probably useless
    hideTimesheetError = () => {
        state.logEntries.clearError();
    }

    incrementWeek = () => {
        if (this.props.loading) {
            return;
        }

        this.setState({
            selectDate: false
        });

        let date = this.state.date.add(7, 'days');
        this.props.routeParams.date = date;

        this.setState({
            date: date,
            showCommander: false
        }, () => {
            this.props.dispatch(logEntryActions.loadOnWeek(this.state.date));
            this.loadTimesheet();
            this.handleResetSubmitModal();
        });
    }

    loadTimesheet = () => {
        if (this.props.currentUser) {
            this.props.dispatch(timesheetActions.loadByUserWeek(
                this.props.currentUser,
                Time.getFormattedYearAndWeek(this.state.date)));
        }
    }

    loadTimesheetUser = (currentUser) => {
        this.props.dispatch(timesheetActions.loadByUserWeek(
            currentUser,
            Time.getFormattedYearAndWeek(this.state.date)
        ));
    }

    openCommander = () => {
        this.setState({
            showCommander: true
        });
    }

    returnKeymaster = () => {
        keymaster.unbind('left');
        keymaster.unbind('right');
        keymaster('left', this.decrementWeek);
        keymaster('right', this.incrementWeek);
    }

    // RENDER METHOD

    render = () => {
        let dates = [
            this.state.date.clone(),
            this.state.date.clone(),
            this.state.date.clone(),
            this.state.date.clone(),
            this.state.date.clone(),
            this.state.date.clone(),
            this.state.date.clone()
        ];

        for (let i = 0; i < dates.length; ++i) {
            dates[i].add(i, 'days');
        }

        let canSubmit = true;
        let writtenOnReturned = false;
        let timeSpent = 0;
        let overtimeSpent = 0;
        let regularTimeSpent = 0; // this is non-overtime time spent

        for (let i = 0; i < dates.length; ++i) {
            let logEntries = this.props.logEntriesByDate[i];
            let timeSpentOnDay = 0;

            for (let j = 0; j < logEntries.length; ++j) {

                if(!logEntries[j].projectName && this.props.returnedFloatingTaskIDs.indexOf(logEntries[j].taskID) !== -1){
                    canSubmit = false;
                    writtenOnReturned = true;
                }

                if (logEntries[j].timer)
                    canSubmit = false;

                if (!logEntries[j].duration || parseInt(logEntries[j].duration) === 0) {
                    canSubmit = false;
                    continue;
                }

                if (!logEntries[j].overtime) {
                    regularTimeSpent += parseInt(logEntries[j].duration);
                    timeSpent += parseInt(logEntries[j].duration);
                } else {
                    overtimeSpent += parseInt(logEntries[j].duration);
                }

                timeSpentOnDay += parseInt(logEntries[j].duration);
            }

            if (timeSpentOnDay >= 1440)
                canSubmit = false;
        }

        let quotaMatched = this.props.currentUser && this.props.currentUser.weeklyQuota && timeSpent === (this.props.currentUser.weeklyQuota * 60);

        let minutesLogged = parseFloat((timeSpent % 60).toFixed(0));
        timeSpent = parseFloat(Math.trunc(timeSpent / 60));
        let overtimeMinutesLogged = parseFloat((overtimeSpent % 60).toFixed(0));
        overtimeSpent = parseFloat(Math.trunc(overtimeSpent / 60));
        regularTimeSpent = parseFloat(Math.trunc(regularTimeSpent / 60));

        let timesheetStatusModal = (
            <Modal show={true} title={<h3>Error creating/editing log entry</h3>} onRequestHide={this.hideTimesheetError}>
                <div className="modal-body">
                    You cannot create or delete log entries in a timesheet that has already been submitted and/or approved.
                </div>
                <div className="modal-footer">
                    <Button onClick={this.hideTimesheetError}>Close</Button>
                </div>
            </Modal>
        );

        let submitModal = <SubmitModal
                              returnKeymaster={this.returnKeymaster}
                              handleClose={this.handleCloseSubmitModal}
                              handleSubmit={this.handleSubmitTimesheet}
                              />;

        let copyDisabled = [];
        for (let i = 0; i < 7; i++) {
            if (i < 6 && this.props.logEntriesByDate[i + 1].length == 0) {
                copyDisabled[i] = false;
            } else {
                copyDisabled[i] = true;
            }
        }

        let timesheetSubmittable = this.props.currentTimesheet && (this.props.currentTimesheet.status === "ENTRY" || this.props.currentTimesheet.status === "FIXING");

        let mobileCheck = {
            Android () {
                return navigator.userAgent.match(/Android/i);
            },
            BlackBerry () {
                return navigator.userAgent.match(/BlackBerry/i);
            },
            iOS () {
                return navigator.userAgent.match(/iPhone|iPad|iPod/i);
            },
            Opera () {
                return navigator.userAgent.match(/Opera Mini/i);
            },
            Windows () {
                return navigator.userAgent.match(/IEMobile/i) || navigator.userAgent.match(/WPDesktop/i);
            },
            any () {
                return (mobileCheck.Android() || mobileCheck.BlackBerry() || mobileCheck.iOS() || mobileCheck.Opera() || mobileCheck.Windows());
            }
        };

        let isMobile = mobileCheck.any();

        let containsDurationlessTasks = false;

        for (let i = 0; i < this.props.logEntriesByDate.length; i++) {
          if (this.props.logEntriesByDate[i].some((entry) => entry.duration === 0)){
            containsDurationlessTasks = true;
            break;
          }
        }

        return (
            <div>
                {
                    this.state.showCommander && (!this.props.currentTimesheet || this.props.currentTimesheet.status === "ENTRY" || this.props.currentTimesheet.status === "FIXING")
                        ? <CommanderConsoleWidget
                              dates={dates}
                              handleClose={this.handleCloseCommander}
                              logEntriesByDate={this.props.logEntriesByDate}
                              ref={ref => this.commander = ref}
                              tasks={this.props.tasks}
                              />
                        : null
                }
                {
                    this.props.logEntryError && this.props.logEntryError < 500 && this.props.logEntryError >= 400 && !this.state.showCommander ? timesheetStatusModal : null
                }
                {
                    !this.state.submitModalClosed && !this.props.loading && canSubmit && quotaMatched && timesheetSubmittable ? submitModal : null
                }
                <LogOverviewHeader
                    canSubmit={canSubmit}
                    closeAllPopovers={this.closeAllPopovers}
                    date={this.state.date}
                    decrementWeek={this.decrementWeek}
                    endDay={dates[6]}
                    handleDateChange={this.handleDateSelect}
                    hoursLogged={timeSpent}
                    incrementWeek={this.incrementWeek}
                    loading={this.props.loading}
                    minutesLogged={minutesLogged}
                    overtimeHoursLogged={overtimeSpent}
                    overtimeMinutesLogged={overtimeMinutesLogged}
                    pmUsers={this.props.pms}
                    regularHoursLogged={regularTimeSpent}
                    startDay={dates[0]}
                    timesheet={this.props.currentTimesheet}
                    weeklyQuota={this.props.currentUser ? this.props.currentUser.weeklyQuota : null}
                    writtenOnReturned={writtenOnReturned}
                    containsDurationlessTasks={containsDurationlessTasks}
                    />
                <br/>
                {
                    this.props.loading ?
                    <Spinner /> :
                    <div className="row week">
                        <div className="col-lg-6 first-half log">
                            <div className="row log">
                                <div className="col-sm-4 log">
                                    <LogEntryDayListWidget
                                        closeAllPopovers={this.closeAllPopovers}
                                        copyDisabled={copyDisabled[0]}
                                        date={dates[0]}
                                        handleLogEntryEvent={this.handleResetSubmitModal}
                                        infoUserTask={this.props.infoUserTask}
                                        isMobile={isMobile}
                                        loadTimesheet={this.loadTimesheet}
                                        logEntries={this.props.logEntriesByDate[0]}
                                        modalPopover={this.state.width < 768}
                                        returnKeymaster={this.returnKeymaster}
                                        tasks={this.props.tasks}
                                        getDay = {(yourself) => {this.day[1] = yourself}}
                                        />
                                </div>
                                <div className="col-sm-4 log">
                                    <LogEntryDayListWidget
                                        closeAllPopovers={this.closeAllPopovers}
                                        copyDisabled={copyDisabled[1]}
                                        date={dates[1]}
                                        handleLogEntryEvent={this.handleResetSubmitModal}
                                        infoUserTask={this.props.infoUserTask}
                                        isMobile={isMobile}
                                        loadTimesheet={this.loadTimesheet}
                                        logEntries={this.props.logEntriesByDate[1]}
                                        modalPopover={this.state.width < 768}
                                        odd
                                        returnKeymaster={this.returnKeymaster}
                                        tasks={this.props.tasks}
                                        getDay = {(yourself) => {this.day[2] = yourself}}
                                        />
                                </div>
                                <div className="col-sm-4 log">
                                    <LogEntryDayListWidget
                                        closeAllPopovers={this.closeAllPopovers}
                                        copyDisabled={copyDisabled[2]}
                                        date={dates[2]}
                                        handleLogEntryEvent={this.handleResetSubmitModal}
                                        infoUserTask={this.props.infoUserTask}
                                        isMobile={isMobile}
                                        loadTimesheet={this.loadTimesheet}
                                        logEntries={this.props.logEntriesByDate[2]}
                                        modalPopover={this.state.width < 768}
                                        returnKeymaster={this.returnKeymaster}
                                        tasks={this.props.tasks}
                                        getDay = {(yourself) => {this.day[3] = yourself}}
                                        />
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-6 log">
                            <div className="row log">
                                <div className="col-sm-4 log">
                                    <LogEntryDayListWidget
                                        closeAllPopovers={this.closeAllPopovers}
                                        copyDisabled={copyDisabled[3]}
                                        date={dates[3]}
                                        handleLogEntryEvent={this.handleResetSubmitModal}
                                        infoUserTask={this.props.infoUserTask}
                                        isMobile={isMobile}
                                        loadTimesheet={this.loadTimesheet}
                                        logEntries={this.props.logEntriesByDate[3]}
                                        modalPopover={this.state.width < 768}
                                        odd
                                        returnKeymaster={this.returnKeymaster}
                                        tasks={this.props.tasks}
                                        getDay = {(yourself) => {this.day[4] = yourself}}
                                        />
                                </div>
                                <div className="col-sm-4 log">
                                    <LogEntryDayListWidget
                                        closeAllPopovers={this.closeAllPopovers}
                                        copyDisabled={copyDisabled[4]}
                                        date={dates[4]}
                                        handleLogEntryEvent={this.handleResetSubmitModal}
                                        infoUserTask={this.props.infoUserTask}
                                        isMobile={isMobile}
                                        loadTimesheet={this.loadTimesheet}
                                        logEntries={this.props.logEntriesByDate[4]}
                                        modalPopover={this.state.width < 768}
                                        returnKeymaster={this.returnKeymaster}
                                        tasks={this.props.tasks}
                                        getDay = {(yourself) => {this.day[5] = yourself}}
                                        />
                                </div>
                                <div className="col-sm-4 log">
                                    <LogEntryDayListWidget
                                        closeAllPopovers={this.closeAllPopovers}
                                        copyDisabled={copyDisabled[5]}
                                        date={dates[5]}
                                        halfHeight
                                        handleLogEntryEvent={this.handleResetSubmitModal}
                                        infoUserTask={this.props.infoUserTask}
                                        isMobile={isMobile}
                                        loadTimesheet={this.loadTimesheet}
                                        logEntries={this.props.logEntriesByDate[5]}
                                        modalPopover={this.state.width < 768}
                                        returnKeymaster={this.returnKeymaster}
                                        tasks={this.props.tasks}
                                        getDay = {(yourself) => {this.day[6] = yourself}}
                                        />
                                    <LogEntryDayListWidget
                                        closeAllPopovers={this.closeAllPopovers}
                                        copyDisabled={copyDisabled[6]}
                                        date={dates[6]}
                                        halfHeight
                                        handleLogEntryEvent={this.handleResetSubmitModal}
                                        infoUserTask={this.props.infoUserTask}
                                        isMobile={isMobile}
                                        loadTimesheet={this.loadTimesheet}
                                        logEntries={this.props.logEntriesByDate[6]}
                                        modalPopover={this.state.width < 768}
                                        returnKeymaster={this.returnKeymaster}
                                        tasks={this.props.tasks}
                                        getDay = {(yourself) => {this.day[7] = yourself}}
                                        />

                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>
        );
    }
}

LogOverview.contextTypes = {
    router: PropTypes.object.isRequired
};

LogOverview.propTypes = {
    currentTimesheet: PropTypes.object,
    dispatch: PropTypes.func,
    infoUserTask: PropTypes.object,
    loading: PropTypes.bool,
    logEntryError: PropTypes.object,
    logEntriesByDate: PropTypes.array,
    pms: PropTypes.array,
    returnedFloatingTaskIDs: PropTypes.array,
    routeParams: PropTypes.object,
    tasks: PropTypes.array,
    currentUser: PropTypes.object
};

const mapStateToProps = (state, ownProps) => {
    let returnedFloatingTaskIDs = [];
    let tasks = state.floatingTasks.allFloatingTasks;

    for(let i in tasks) {
        if(state.floatingTasks.allFloatingTasks[i].returned)
            returnedFloatingTaskIDs.push(state.floatingTasks.allFloatingTasks[i].id)
    }

    tasks = tasks.concat(state.tasks.tasks);

    let logEntriesByDate = [[], [], [], [], [], [], []];
    let logEntriesOnWeek = state.logEntries.logEntriesOnWeek;

    let queryParams = ownProps.routeParams;
    let date = state.timesheets.currentTimesheet ? moment(state.timesheets.currentTimesheet.startDate, "YYYY-MM-DD") : (queryParams.date ? queryParams.date : moment().startOf('isoweek'));
    for (let i = logEntriesOnWeek.length - 1; i >= 0; i--) {
        let logEntryDate = moment(logEntriesOnWeek[i].date, "YYYY-MM-DD");

        let diff = logEntryDate.diff(moment(date.format("YYYY-MM-DD"), "YYYY-MM-DD"), 'days');

        if (diff < 0 || diff > 6) break;

        logEntriesByDate[diff].push(logEntriesOnWeek[i]);
    }

    return {
        currentTimesheet: state.timesheets.currentTimesheet,
        date: date,
        infoUserTask: state.userTasks.userTaskByID ? state.userTasks.userTaskByID.userTask : null,
        loading: state.logEntries.loading || state.users.loading,
        logEntryError: state.logEntries.error,
        logEntriesByDate: logEntriesByDate,
        pms: state.users.pms.users,
        returnedFloatingTaskIDs: returnedFloatingTaskIDs,
        tasks: tasks,
        currentUser: state.users.currentUser
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch: dispatch
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LogOverview);



/** WEBPACK FOOTER **
 ** ./src/app/components/LogOverview.js
 **/